export const IMAGE_HEIGHT = 48;
export const IMAGE_WIDTH = 48;

export const redirectingIn = (time: number) => {
  return `redirecting in ${time}s`;
};
